import URL from '../api_url';

export const PROGRAM_API = `${URL}/program`;

export const PROGRAMS_API = `${URL}/programs`;